export enum ProjectionEvaluationRangeId {
    NO_RANGE,
    DAY_15 = 15,
    DAY_30 = 30,
    DAY_60 = 60,
}

export const ProjectionEvaluationRanges = {
    [ProjectionEvaluationRangeId.DAY_15]: 15,
    [ProjectionEvaluationRangeId.DAY_30]: 30,
    [ProjectionEvaluationRangeId.DAY_60]: 60,
};
